import { FileText, CheckCircle2 } from "lucide-react";

export default function ReportMockup({ className = "" }) {
  return (
    <div className={`rounded-xl border border-border bg-card shadow-sm overflow-hidden ${className}`}>
      <div className="px-6 py-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <FileText className="h-4 w-4 text-accent" />
          <span className="font-display font-bold text-foreground">Executive Report</span>
        </div>
        <span className="text-[10px] text-muted-foreground">Generated · Africa Tech Forum 2026</span>
      </div>

      <div className="p-6 space-y-5 text-sm">
        <section>
          <p className="text-xs uppercase tracking-[0.16em] text-accent font-bold mb-1.5">Executive Summary</p>
          <p className="text-muted-foreground leading-relaxed">
            The forum engaged 342 attendees across 3 sessions, capturing 58 audience questions with an average
            feedback score of 4.6/5. Engagement peaked during the fintech panel.
          </p>
        </section>

        <div className="grid grid-cols-2 gap-5">
          <section>
            <p className="text-xs uppercase tracking-[0.16em] text-foreground font-bold mb-2">Key Themes</p>
            <ul className="space-y-1.5 text-muted-foreground">
              <li>· Regulatory fragmentation</li>
              <li>· Cross-border scaling</li>
              <li>· Early-stage hiring</li>
            </ul>
          </section>
          <section>
            <p className="text-xs uppercase tracking-[0.16em] text-foreground font-bold mb-2">Top Concerns</p>
            <ul className="space-y-1.5 text-muted-foreground">
              <li>· Funding availability</li>
              <li>· Talent retention</li>
            </ul>
          </section>
        </div>

        <section>
          <p className="text-xs uppercase tracking-[0.16em] text-foreground font-bold mb-2">Recommendations & Action Items</p>
          <ul className="space-y-2">
            {[
              "Publish answers to the 6 most upvoted questions",
              "Share session recordings within 48 hours",
              "Follow up with speakers on unanswered topics",
            ].map((t, i) => (
              <li key={i} className="flex items-start gap-2 text-muted-foreground">
                <CheckCircle2 className="h-4 w-4 text-accent mt-0.5 shrink-0" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
